import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import LogoBlueIcon from '../components/Icons/Logo/LogoBlue.icon';
import LoveIcon from '../components/Icons/Love.icon';

export const StyledCopyright = styled.div`
  display: flex;
  gap: 10px;
  font-size: 12px;
  align-items: center;
  color: ${({ theme }) => theme.colors.LABEL};
  z-index: 2;
`;
export const StyledInitScreen = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: calc(100vh - 40px);
  padding: 20px;
`;
export const StyledInitScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const StyledLoadingText = styled.div`
  bottom: 0;
  text-align: center;
  font-size: 12px;
  position: relative;
  color: ${({ theme }) => theme.colors.LABEL};
  line-height: 14px;
`;
const StyledInfiniteLoader = styled.div`
  left: -20px;
  height: 3px;
  top: 2px;
  position: absolute;
  width: 200%;
  background-color: ${({ theme }) => theme.colors.BLUE.B200};
  transform: translate3d(0, 0, 0);
  background-image: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.BLUE.B400} 25%,
    transparent 25%,
    transparent 50%,
    ${({ theme }) => theme.colors.BLUE.B400} 50%,
    ${({ theme }) => theme.colors.BLUE.B400} 75%,
    transparent 75%,
    transparent
  );
  background-size: 10px 10px;
  animation: ${({ theme }) => theme.animations.preload} 1500ms linear infinite;
`;
const StyledPreload = styled.div`
  width: 100%;
  position: relative;
  height: 7px;
  overflow: hidden;
`;
const StyledPreloadWrap = styled.div`
  width: 189px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export interface InitScreenProps {
  stepLabel?: string;
}

const LOGO_ICON_SIZE = 82;

const InitScreen = ({ stepLabel }: InitScreenProps) => {
  const { t } = useTranslation();
  return (
    <StyledInitScreen>
      <div />
      <StyledInitScreenContent>
        <LogoBlueIcon width={LOGO_ICON_SIZE} height={LOGO_ICON_SIZE} />
        <StyledPreloadWrap>
          <StyledPreload>
            <StyledInfiniteLoader />
          </StyledPreload>
          <StyledLoadingText>
            {t(stepLabel || 'Signing in...')}
          </StyledLoadingText>
        </StyledPreloadWrap>
      </StyledInitScreenContent>
      <StyledCopyright>
        <span>{t('Created with')}</span>
        <LoveIcon />
        <span>{t('by IntexSoft')}</span>
      </StyledCopyright>
    </StyledInitScreen>
  );
};

export default InitScreen;
